"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

var _Button = _interopRequireDefault(require("../Button"));

var _utils = _interopRequireDefault(require("./utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  box-shadow: 0 4px 4px -1px rgba(0, 0, 0, 0.1),\n    0 1px 0px 0px rgba(0, 0, 0, 0.075);\n  border-radius: 8px;\n  transform: scale(0.9);\n  transition: all 0.125s ease-out;\n  transform-origin: top center;\n  opacity: 0;\n  pointer-events: none;\n  &.active {\n    transform: scale(1);\n    visibility: visible;\n    opacity: 1;\n    pointer-events: initial;\n    z-index: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ListStyled = (0, _styledComponents["default"])(_Box["default"])(_templateObject());
ListStyled.defaultProps = {
  top: '2.25rem',
  left: '0',
  display: 'flex',
  flexDirection: 'column',
  bg: 'white',
  color: 'primary',
  padding: 'xsmall',
  width: '200px',
  m: '0'
};
var DropdownStyled = (0, _styledComponents["default"])(_Box["default"])(_templateObject2());
DropdownStyled.defaultProps = {
  display: 'flex'
};

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      title = _ref.title,
      buttonSize = _ref.buttonSize,
      variant = _ref.variant,
      hideIcon = _ref.hideIcon,
      hover = _ref.hover,
      hoverbg = _ref.hoverbg,
      shape = _ref.shape,
      mr = _ref.mr,
      boxProps = _ref.boxProps,
      buttonProps = _ref.buttonProps,
      _ref$disableClose = _ref.disableClose,
      disableClose = _ref$disableClose === void 0 ? false : _ref$disableClose,
      rest = _objectWithoutProperties(_ref, ["children", "title", "buttonSize", "variant", "hideIcon", "hover", "hoverbg", "shape", "mr", "boxProps", "buttonProps", "disableClose"]);

  var actionEl = _react["default"].useRef(null);

  var dropEl = _react["default"].useRef(null);

  var _useDropdown = (0, _utils["default"])(dropEl, actionEl),
      _useDropdown2 = _slicedToArray(_useDropdown, 2),
      isOpen = _useDropdown2[0],
      toggleDrop = _useDropdown2[1];

  var onClick = function onClick() {
    if (!disableClose) {
      toggleDrop();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(DropdownStyled, _extends({
    className: isOpen ? 'active' : ''
  }, boxProps), /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    fontWeight: "600",
    ref: actionEl,
    buttonSize: buttonSize,
    variant: variant,
    hideIcon: hideIcon,
    shape: shape,
    hover: hover,
    hoverbg: hoverbg,
    mr: mr || '0',
    onClick: toggleDrop
  }, buttonProps), title || 'Select', !hideIcon && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isOpen ? '+' : '-')), /*#__PURE__*/_react["default"].createElement(ListStyled, _extends({
    ref: dropEl,
    className: isOpen ? 'active' : '',
    onClick: onClick
  }, rest), children));
};

Dropdown.defaultProps = {
  display: 'inline-flex',
  buttonSize: 'medium',
  variant: 'custom',
  hoverbg: 'rgba(0,0,0,0.125)',
  mr: 'xxxsmall'
};
var _default = Dropdown;
exports["default"] = _default;